// extracted by mini-css-extract-plugin
export default {"inc":"_f4gJz2RkqlbnrJpwsEc","dec":"qn09vXaJ10JHNYiizq8x","fg":"hoGUGAflYxrX2h9rJLDA","placeHolderShimmer":"JgjaFAR_12kAbXR37sjh"};